'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002eintelacloud$002eui$002e$002dMarkdown$0024$002dBlock from "./io.intela.sites.intelacloud.ui.-Markdown$-Block.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Items(items) {
  this.ig = null;
  this.ig = items;
}
export { $c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Items as $c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Items };
$p = $c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Items.prototype = new $j_io$002eintela$002esites$002eintelacloud$002eui$002e$002dMarkdown$0024$002dBlock.$h_Lio_intela_sites_intelacloud_ui_Markdown$Block();
$p.constructor = $c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Items;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_ui_Markdown$Block$Items() {
}
export { $h_Lio_intela_sites_intelacloud_ui_Markdown$Block$Items as $h_Lio_intela_sites_intelacloud_ui_Markdown$Block$Items };
$h_Lio_intela_sites_intelacloud_ui_Markdown$Block$Items.prototype = $p;
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, (-58214229), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Items)) {
    var x = this.ig;
    var x$2 = x$0.ig;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 1;
});
$p.I = (function() {
  return "Items";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.ig;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_intelacloud_ui_Markdown$Block$Items(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bO)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_ui_Markdown$Block$Items as $isArrayOf_Lio_intela_sites_intelacloud_ui_Markdown$Block$Items };
var $d_Lio_intela_sites_intelacloud_ui_Markdown$Block$Items = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Items, "io.intela.sites.intelacloud.ui.Markdown$Block$Items", ({
  bO: 1,
  aJ: 1,
  b: 1,
  e: 1,
  a: 1,
  Q: 1
}));
export { $d_Lio_intela_sites_intelacloud_ui_Markdown$Block$Items as $d_Lio_intela_sites_intelacloud_ui_Markdown$Block$Items };
//# sourceMappingURL=io.intela.sites.intelacloud.ui.-Markdown$-Block$-Items.js.map
